import { useSelector } from "react-redux";
import styles from "./Ingredients.module.css";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { RootState } from "../../../redux/store";

interface IIngredients {
    ingredients: string;
    isMobile: boolean;
    position: number;
}

const Ingredients: React.FC<IIngredients> = (props) => {
    const { t } = useTranslation();
    const [contentHeight, setContentHeight] = useState("0px");
    const elementRef = useRef<HTMLDivElement>(null);
    const isMobile = useSelector((state: RootState) => state.client.isMobile);
    const [scrollPosition, setScrollPosition] = useState(0);
    var ingredientsArray = props.ingredients.split("\n");
    const ingredientsList = ingredientsArray.map((ingredient: string, index: number) => (
        <li key={`ingredient-${index}`}>{ingredient}</li>
    ));

    const handleScroll = () => {
        setScrollPosition(window.scrollY);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        if (elementRef.current) {
            const contentHeight = elementRef.current.scrollHeight;
            setContentHeight(`${contentHeight}px`);
        }
    }, []);

    if (props.isMobile) {
        return (
            <div className={styles.listMobile}>
                <h2 className={styles.title}>{t("components.feature.ingredients")}:</h2>
                <div ref={elementRef} className={styles.containerMobile}>
                    {ingredientsList}
                </div>
            </div>
        );
    } else {
        return (
            <div
                className={`${styles.listDesktop} mt-1`}
                style={{
                    top:
                        scrollPosition < props.position
                            ? props.position - window.scrollY + (isMobile ? 5 : 0) + "px"
                            : "5px",
                    height: scrollPosition > props.position ? "97%" : "90%",
                }}
            >
                <h2 className={styles.title}>{t("components.feature.ingredients")}:</h2>
                <div ref={elementRef} className={styles.containerDesktop} style={{ height: contentHeight }}>
                    {ingredientsList}
                </div>
            </div>
        );
    }
};

export default Ingredients;
